/**
 * Shared constants used across the application
 * Centralized to avoid duplication and ensure consistency
 */

// Mexican states for address forms
export const MEXICAN_STATES = [
  'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas',
  'Chihuahua', 'Ciudad de México', 'Coahuila', 'Colima', 'Durango', 'Estado de México',
  'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco', 'Michoacán', 'Morelos', 'Nayarit',
  'Nuevo León', 'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí',
  'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
];

// Shipping countries supported
export const SHIPPING_COUNTRIES = [
  { code: 'MX', name: 'México', flag: '🇲🇽' },
  { code: 'US', name: 'Estados Unidos', flag: '🇺🇸' },
  { code: 'ES', name: 'España', flag: '🇪🇸' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
  { code: 'CL', name: 'Chile', flag: '🇨🇱' },
  { code: 'PE', name: 'Perú', flag: '🇵🇪' },
  { code: 'OTHER', name: 'Otro país', flag: '🌎' }
];

// Meeting point name mapping
export const MEETING_POINT_NAMES = {
  'plaza_ciudad_jardin': 'Plaza Ciudad Jardín',
  'parque_del_pueblo': 'Parque del Pueblo',
  'metro_pantitlan': 'Metro Pantitlán',
  'plaza_aragon': 'Plaza Aragón',
  'centro_nezahualcoyotl': 'Centro de Nezahualcóyotl'
};

// Payment method labels
export const PAYMENT_METHOD_LABELS = {
  card: 'Tarjeta',
  bank_transfer: 'Transferencia',
  cash_on_delivery: 'Contra Entrega'
};

// Delivery method labels
export const DELIVERY_METHOD_LABELS = {
  meeting_point: 'Punto de Encuentro',
  shipping: 'Envío a Domicilio'
};

// API base URL
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
